import {RouteRecordRaw} from 'vue-router';

export enum ProfileCreationFunnelMode {
    FREELANCER = 'FREELANCER',
    STRATEGY = 'STRATEGY',
}

export enum ProfileCreationStepGroup {
    SIGNUP = 'SIGNUP',
    COMPLETION = 'COMPLETION',
}

export type ProfileCreationStep = {
    name: string;
    route: string;
    stepNumber: number;
    stepCount: number;
    stepPercentage: number;
    previousStepName: string | null;
    nextStepName: string | null;
    group: ProfileCreationStepGroup;
    component: any;
};

export type RoutesConfig = {
    routes: RouteRecordRaw[];
    creationFirstStep: string;
    completionFirstStep: string;
};

export type ProfileCreationSteps = ProfileCreationStep[];
